import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";
import { TiDelete, TiPlus } from "react-icons/ti";
import { getCurrentDate } from "../../../Utilitie";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Loading from "../../../Extra/Loading";

const createEntry = () => ({
  isEdited: false,

  via: null,
  quota: null,
  restriction_by_name: null,
  commodity: null,
  wagons: null,
  wagon_type: null,
  fcn_no: null,
  order_date: null,
  order_time: null,
  restriction_remark: null,
  remarks: null,
  action: null,

  sidings: [
    {
      pick_drop_point: "",
      pick_drop_flag: "S",
    },
  ],

  destinations: [
    {
      pick_drop_point: "",
      pick_drop_flag: "D",
    },
  ],
});
const IndentUpdate = ({ siding, rakeType, commodity, destination }) => {
  const { userData } = useGlobalContext();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [date, setDate] = useState(getCurrentDate());

  const [act, setAct] = useState("Due");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [entries, setEntries] = useState([createEntry()]);
  const [updateData, setUpdateData] = useState([]);
  const fetchData = async () => {
    setLoading(true);
    try {
      const url =
        act === "Due"
          ? `${urlPrefix}getMultipleTableData?hdr_table=t_indent_hdr&dtl_table=t_indent_dtls&hdr_pk=id&dtl_fk=ind_id&action=due`
          : act === "Pending"
            ? `${urlPrefix}getMultipleTableData?hdr_table=t_indent_hdr&dtl_table=t_indent_dtls&hdr_pk=id&dtl_fk=ind_id&action=pending`
            : `${urlPrefix}getMultipleTableData?hdr_table=t_indent_hdr&dtl_table=t_indent_dtls&hdr_pk=id&dtl_fk=ind_id&order_date=${date}`;

      const response = await axios.get(url);

      if (response.data.success === true) {
        setUpdateData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, [act, date]);
  useEffect(() => {
    if (!updateData || !Array.isArray(updateData)) return;

    const formattedData = updateData.map((item) => ({
      ...item.hdr_data,
      isEdited: false,
      sidings:
        item.dtl_data?.filter((x) => x.pick_drop_flag === "S")?.length > 0
          ? item.dtl_data.filter((x) => x.pick_drop_flag === "S")
          : [
              {
                pick_drop_point: "",
                pick_drop_flag: "S",
              },
            ],

      destinations:
        item.dtl_data?.filter((x) => x.pick_drop_flag === "D")?.length > 0
          ? item.dtl_data.filter((x) => x.pick_drop_flag === "D")
          : [
              {
                pick_drop_point: "",
                pick_drop_flag: "D",
              },
            ],
    }));

    setEntries(formattedData);
  }, [updateData]);
  const keys = [
    "Sr No.",
    "siding",
    "destination",
    "via",
    "quota",
    "restriction_by_name",
    "commodity",
    "wagons",
    "wagon_type",
    "fcn_no",
    "order_date",
    "order_time",
    "restriction_remark",
    "remarks",
    "action",
  ];

  const handleChange = (rowIndex, key, value) => {
    const temp = [...entries];

    temp[rowIndex][key] = value;
    temp[rowIndex].isEdited = true;

    setEntries(temp);
  };
  const addSiding = (entryIndex) => {
    const temp = [...entries];

    temp[entryIndex].sidings.push({
      pick_drop_point: "",
      pick_drop_flag: "S",
    });

    temp[entryIndex].isEdited = true;

    setEntries(temp);
  };

  const addDestination = (entryIndex) => {
    const temp = [...entries];

    temp[entryIndex].destinations.push({
      pick_drop_point: "",
      pick_drop_flag: "D",
    });

    temp[entryIndex].isEdited = true;

    setEntries(temp);
  };

  const removeSiding = (entryIndex, index) => {
    const temp = [...entries];

    temp[entryIndex].sidings = temp[entryIndex].sidings.filter(
      (_, i) => i !== index,
    );

    temp[entryIndex].isEdited = true;

    setEntries(temp);
  };
  const removeDestination = async (entryIndex, index, id) => {
    try {
      if (id) {
        const response = await fetch(`${urlPrefix}delete/anytable`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            table_name: "t_indent_dtls",
            column_name: "id",
            value: id,
          }),
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result?.message || "Delete failed");
        }
      }

      const temp = [...entries];

      temp[entryIndex].destinations = temp[entryIndex].destinations.filter(
        (_, i) => i !== index,
      );

      temp[entryIndex].isEdited = true;

      setEntries(temp);
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to delete destination");
    }
  };
  const handleSubmit = async () => {
    const editedEntries = entries.filter((entry) => entry.isEdited);

    if (editedEntries.length === 0) {
      toast.error("No changes found");
      return;
    }
    const headerPayload = {
      table_name: "t_indent_hdr",
      rows: editedEntries.map((entry) => ({
        id: entry.id,
        updates: {
          commodity: entry.commodity,
          quota: entry.quota,
          via: entry.via,
          restriction_by_name: entry.restriction_by_name,
          wagons: entry.wagons,
          wagon_type: entry.wagon_type,
          fcn_no: entry.fcn_no,
          order_date: entry.order_date ? entry.order_date.slice(0, 10) : null,
          order_time: entry.order_time,
          restriction_remark: entry.restriction_remark,
          remarks: entry.remarks,
          action: entry.action,
          updated_by: userData.id,
        },
      })),
    };

    const allDetails = editedEntries.flatMap((entry) => [
      ...entry.sidings.map((item) => ({
        ...item,
        ind_id: entry.id,
      })),
      ...entry.destinations.map((item) => ({
        ...item,
        ind_id: entry.id,
      })),
    ]);

    const detailUpdatePayload = {
      table_name: "t_indent_dtls",
      rows: allDetails
        .filter((item) => item.id)
        .map((item) => ({
          id: item.id,
          updates: {
            pick_drop_point: item.pick_drop_point,
            pick_drop_flag: item.pick_drop_flag,
          },
        })),
    };

    const detailInsertPayload = {
      table_name: "t_indent_dtls",
      data: allDetails
        .filter((item) => !item.id)
        .map((item) => ({
          ind_id: item.ind_id,
          pick_drop_point: item.pick_drop_point,
          pick_drop_flag: item.pick_drop_flag,
        })),
    };
    try {
      let response = await fetch(
        `${urlPrefix}updateAllMasterData
`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(headerPayload),
        },
      );

      if (!response.ok) {
        const result = await response.json();
        throw new Error(result.message || "Header update failed");
      }

      if (detailUpdatePayload.rows.length > 0) {
        response = await fetch(`${urlPrefix}updateAllMasterData`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(detailUpdatePayload),
        });

        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.message || "Detail update failed");
        }
      }

      if (detailInsertPayload.data.length > 0) {
        response = await fetch(
          `${urlPrefix}insert/insertData
`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(detailInsertPayload),
          },
        );

        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.message || "Detail insert failed");
        }
      }

      toast.success("Data updated successfully");
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Operation failed");
    }
  };
  const inputStyle = {
    width: "110px",
    background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };
  const selectStyle = {
    width: "100px",
    backgroundColor: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    paddingRight: "2rem",
  };
  return (
    <div className="container-fluid mt-3">
      {loading && <Loading />}
      <h4 className="bg-dark text-white p-2 text-center">CLS Indent </h4>

      <div className="d-flex justify-content-center my-3">
        <div
          className="position-relative d-flex rounded-pill border bg-light"
          style={{ width: "300px", height: "42px" }}
        >
          <div
            className="position-absolute top-0 h-100 rounded-pill"
            style={{
              backgroundColor: "#000000",
              width: "33.33%",
              transition: "0.3s",
              transform:
                act === "Due"
                  ? "translateX(0%)"
                  : act === "Pending"
                    ? "translateX(100%)"
                    : "translateX(200%)",
            }}
          />

          {["Due", "Pending", "Update"].map((item) => (
            <div
              key={item}
              className={`flex-fill d-flex align-items-center justify-content-center fw-semibold position-relative ${
                act === item ? "text-white" : "text-dark"
              }`}
              onClick={() => setAct(item)}
              style={{ cursor: "pointer", zIndex: 1 }}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
      {act === "Update" && (
        <div className="d-flex justify-content-center">
          <div className="my-3">
            <input
              type="date"
              className="form-control d-inline-block"
              style={{ width: "180px", fontSize: "0.9rem" }}
              value={date}
              max={getCurrentDate()}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
        </div>
      )}
      <div className="table-responsive">
        <table className="table table-bordered" style={{ fontSize: "12px" }}>
          <thead>
            <tr className="table-dark">
              {keys.map((key) => (
                <th key={key}>{key.replaceAll("_", " ").toUpperCase()}</th>
              ))}
            </tr>
          </thead>
          <tbody className="border p-3 bg-light border-dark border-4 ">
            {entries.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <tr>
                  {keys.map((key) => (
                    <td key={key}>
                      {key === "siding" ? (
                        row.sidings.map((item, idx) => (
                          <div
                            key={idx}
                            className="d-flex mb-2 "
                            style={{ width: "120px" }}
                          >
                            <select
                              className="form-select form-select-sm shadow"
                              style={selectStyle}
                              value={item.pick_drop_point}
                              onChange={(e) => {
                                const temp = [...entries];
                                temp[rowIndex].sidings[idx].pick_drop_point =
                                  e.target.value;
                                temp[rowIndex].isEdited = true;
                                setEntries(temp);
                              }}
                            >
                              <option value="">Select</option>
                              {siding.map((s, i) => (
                                <option key={i} value={s}>
                                  {s}
                                </option>
                              ))}
                            </select>
                          </div>
                        ))
                      ) : key === "destination" ? (
                        <div className="row " style={{ width: "320px" }}>
                          {row.destinations.map((item, idx) => (
                            <div
                              key={idx}
                              className=" "
                              style={{ maxWidth: "130px" }}
                            >
                              <div className="d-flex mb-2  ">
                                <select
                                  className="form-select form-select-sm shadow"
                                  style={selectStyle}
                                  value={item.pick_drop_point}
                                  onChange={(e) => {
                                    const temp = [...entries];
                                    temp[rowIndex].destinations[
                                      idx
                                    ].pick_drop_point = e.target.value;
                                    temp[rowIndex].isEdited = true;
                                    setEntries(temp);
                                  }}
                                >
                                  <option value="">Select</option>
                                  {destination.map((s, i) => (
                                    <option key={i} value={s}>
                                      {s}
                                    </option>
                                  ))}
                                </select>

                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() =>
                                    removeDestination(rowIndex, idx, item.id)
                                  }
                                >
                                  &times;
                                </button>
                              </div>
                            </div>
                          ))}
                          <div style={{ maxWidth: "20px" }}>
                            <button
                              className="btn btn-success btn-sm "
                              onClick={() => addDestination(rowIndex)}
                            >
                              <TiPlus />
                            </button>
                          </div>
                        </div>
                      ) : key === "Sr No." ? (
                        <h1 class="badge text-bg-dark p-2">{rowIndex + 1}</h1>
                      ) : // : key === "add destination" ? (
                      //   <button
                      //     className="btn btn-success btn-sm"
                      //     onClick={() => addDestination(rowIndex)}
                      //   >
                      //     <TiPlus />
                      //   </button>
                      // )
                      // : key === "add siding" ? (
                      //   <button
                      //     className="btn btn-success btn-sm"
                      //     onClick={() => addSiding(rowIndex)}
                      //   >
                      //     <TiPlus />
                      //   </button>
                      // )
                      key === "order_time" ? (
                        <input
                          type="time"
                          className="form-select form-select-sm shadow"
                          style={inputStyle}
                          value={row[key] ? row[key] : ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "order_date" ? (
                        <input
                          type="date"
                          className=" form-select-sm shadow"
                          style={inputStyle}
                          value={row[key] ? row[key]?.slice(0, 10) : null}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "fcn_no" || key === "wagons" ? (
                        <input
                          className="form-select form-select-sm shadow"
                          style={inputStyle}
                          type="number"
                          value={row[key] || ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "action" ? (
                        <select
                          className="form-select form-select-sm shadow"
                          style={selectStyle}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          <option value={"pending"}>{"pending"}</option>{" "}
                          <option value={"due"}>{"due"}</option>
                          <option value={"accept"}>{"accept"}</option>
                          <option value={"reject"}>{"reject"}</option>
                          <option value={"placed"}>{"placed"}</option>
                        </select>
                      ) : key === "commodity" ? (
                        <select
                          className="form-select form-select-sm shadow"
                          style={selectStyle}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          {commodity.map((item, i) => (
                            <option key={i} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      ) : key === "wagon_type" ? (
                        <select
                          className="form-select form-select-sm shadow"
                          style={selectStyle}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          {rakeType.map((item, i) => (
                            <option key={i} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type="text"
                          className="form-select form-select-sm shadow"
                          style={inputStyle}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      )}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-center">
        <button className="btn btn-success" onClick={handleSubmit}>
          Upload
        </button>
      </div>
    </div>
  );
};

export default IndentUpdate;
